export enum DialogStyle {
    Normal = 'sh-dialog',
    Wide = 'sh-dialog--wide',
    ExtraWide = 'sh-dialog--extra-wide',
    ExtraExtraWide = 'sh-dialog--extra-extra-wide',
    FullScreen = 'sh-dialog--full-screen',
    ContentOnly = 'sh-dialog--content-only'
}
